import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { create } from '../../services/upload-files.service';
import { addFacilities, getFacilitiesSuccess, start } from '../../store/slices/FacilitiesSlice';

function AddFacilityForm(props) {

    const [formData, setFormData] = useState({
        name: '',
        location: '',
        phone: '',
        owner: '',
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();

    const userdetails = JSON.parse(localStorage.getItem('userdetails'))

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            employeeId: userdetails.employee_id,
            company_id: userdetails.company_id
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ""
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (formData.name.trim() === "") {
            newErrors.name = "Please Enter Facility Name";
        }

        if (formData.location.trim() === "") {
            newErrors.location = "Please Enter Location";
        }

        if (formData.phone.trim() === "") {
            newErrors.phone = "Please Enter Phone";
        }

        if (formData.owner.trim() === "") {
            newErrors.owner = "Please Enter Owner";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            props.onHide();
            if (formData) {
                dispatch(start());
                create(formData, 'facilities').then((res) => {
                    if (res.status == 'success') {
                        props.setMessage({ "success": "Asset added!" })
                        dispatch(addFacilities(res.data));
                        setTimeout(() => {
                            props.setMessage({});
                        }, 2000);

                    }
                })

            }

        }
    };

    const resetForm = () => {
        setFormData({
            name: '',
            location: '',
            phone: '',
            owner: '',
        });
        setErrors({});
    };

    const handleModalClose = () => {
        resetForm();
        props.onHide();
    };

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={handleModalClose}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Add Asset
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit} onReset={resetForm}>
                    <div className="mb-3 error-color">
                        <label htmlFor="name" className="form-label">
                            Company Asset Name:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            aria-describedby="facilitynameHelp"
                            onChange={handleInputChange}
                            value={formData.name}
                        />
                        {errors.name && <span className='error'>{errors.name}</span>}
                    </div>
                    <div className="mb-3 error-color">
                        <label htmlFor="type" className="form-label">
                            Asset Type:
                        </label>
                        <select 
                            id="type" 
                            name="type" 
                            className="form-control"
                            onChange={handleInputChange}
                            value={formData.type || ''}
                        >
                            <option value="">Please Select</option>
                            <option value="factory">Factory</option>
                            <option value="office">Office</option>
                            <option value="warehouse">Warehouse</option>
                        </select>
                        {errors.type && <span>{errors.type}</span>}
                    </div>
                    <div className="mb-3 error-color">
                        <label htmlFor="location" className="form-label">
                            Location:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="location"
                            name="location"
                            aria-describedby="locationHelp"
                            onChange={handleInputChange}
                            value={formData.location}
                        />
                        {errors.location && <span>{errors.location}</span>}
                    </div>
                    <div className="mb-3 error-color">
                        <label htmlFor="phone" className="form-label">
                            Phone:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="phone"
                            name="phone"
                            aria-describedby="phoneHelp"
                            onChange={handleInputChange}
                            value={formData.phone}
                        />
                        {errors.phone && <span>{errors.phone}</span>}
                    </div>
                    <div className="mb-3 error-color">
                        <label htmlFor="owner" className="form-label">
                            Asset Head:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="owner"
                            name="owner"
                            aria-describedby="ownerHelp"
                            onChange={handleInputChange}
                            value={formData.owner}
                        />
                        {errors.owner && <span>{errors.owner}</span>}
                    </div>
                    <button type="submit" className="btn btn-primary btn-add">
                        Add
                    </button>
                    <button type="reset" className="btn btn-primary btn-add">
                        Reset
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default AddFacilityForm;